import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { Dialog, Icon, IconSize, Button } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Column, Table2, Cell, RegionCardinality } from "@blueprintjs/table";

import styled from 'styled-components';

import { setSelectedProject, setProjectSelectVisible } from '$root/store/actions';
import { useAuth } from '$root/contexts/auth';


const COLUMN = {
    VIEWPOINT:'Viewpoint',
    PANODATE:'Pano date',
    TAG:'Tag',
    DATE:'Tag date',
    STATUS:'Status',
    CATEGORY:'Category',
    DISCIPLINE:'Discipline',
    EDITEDBY:'EditedBy',
    TITLE:'Title',
    COMMENT:'Comment',
    PHOTO:'Photo',
};


export default function TagList(props) {

    const { projectId, onShowHistoryImage, onJumpToTag } = props;
    const { getProtectedResource, postFormDataProtected } = useAuth();

    const thumbnailCache = useRef({});

    const [ tags, setTags ] = useState({
        tags: [],
    });
    const [ loadThumbnailCache, setLoadThumbnailCache ] = useState(false);


    useEffect(() => {
        getProtectedResource(`/tag2.php?task=tag-by-project&pid=${projectId}`)
            .then(response => {
                thumbnailCache.current = {};
                setTags(old => ({
                    ...old,
                    tags:response.data.tags,
                }));
            })
            .catch((err) => {
                console.error(err)
            })
    }, [projectId]);


    useEffect(() => {
        if (!thumbnailCache.current)
            return;

        for (let i = 0; i < tags.tags.length; i++) {
            try {
                if (_.has(thumbnailCache.current, tags.tags[i].history_id))
                    continue;
            }
            catch (e) {
                console.error(e)
            }

            getProtectedResource(`/tag2.php?task=tag-photo-by-history&thid=${tags.tags[i].history_id}&thumbnail`, 'arraybuffer')
                .then(response => {
                    const blob = new Blob([ response.data ]);
                    if (blob.size) {
                        const url = URL.createObjectURL(blob);

                        thumbnailCache.current[tags.tags[i].history_id] = {
                            valid:true,
                            url
                        };
                    }
                    else {
                        thumbnailCache.current[tags.tags[i].history_id] = {
                            valid:false,
                        };
                    }

                    setLoadThumbnailCache(old => !old);
                })
                .catch((err) => {
                    console.error(err)
                })
            ;
            break;
        }

    }, [tags, loadThumbnailCache]);


    const cellRenderer = useCallback((row, col) => {
        if (tags.tags.length === 0)
            return <Cell />;

        const tag = tags.tags[row];

        switch(col)
        {
        case 0:
            return <Cell>{tag.viewpoint}</Cell>;
        case 1:
            return <Cell>{tag.pano_created_on}</Cell>;
        case 2:
            return (
                <Cell>
                    <span style={{cursor:'pointer', textDecoration:'underline'}}
                          onClick={() => onJumpToTag(tag.plan_id, tag.document_id, tag.viewpoint_id, tag.yaw, tag.pitch)}
                    >
                        {tag.tag}
                    </span>
                </Cell>
            );
        case 3:
            return <Cell><Icon icon={IconNames.SYMBOL_SQUARE} size={IconSize.LARGE} color={tag.status_bgcolor} />{tag.status}</Cell>;
        case 4:
            return <Cell><Icon icon={IconNames.SYMBOL_SQUARE} size={IconSize.LARGE} color={tag.discipline_bgcolor} />{tag.discipline}</Cell>;
        case 5:
            return <Cell><Icon icon={IconNames.SYMBOL_SQUARE} size={IconSize.LARGE} color={tag.category_bgcolor} />{tag.category}</Cell>;
        case 6:
            return <Cell>{tag.created_at_date}</Cell>;
        case 7:
            return <Cell>{tag.title}</Cell>;
        case 8:
            return <Cell>{tag.comment}</Cell>;
        case 9:
            return <Cell>{tag.edited_by}</Cell>;
        case 10:
            if (tag.has_photo &&
                _.has(thumbnailCache.current, tag.history_id)) {
                const entry = thumbnailCache.current[tag.history_id];
                if (entry.valid) {
                    return (
                        <Cell>
                            <img src={entry.url}
                                 width={128}
                                 height={80}
                                 style={{cursor:'pointer'}}
                                 onClick={() => onShowHistoryImage && onShowHistoryImage(tag.history_id)}
                            />
                        </Cell>);
                }
            }
            break;
        }

        return <Cell />
    }, [tags]);


    return (
        <>
            <div style={{width: '100%', height: '100%', padding:8, paddingBottom:48}}>
                <Table2
                    numRows={tags.tags.length}
                    enableMultipleSelection={false}
                    enableRowResizing={false}
                    selectionModes={[RegionCardinality.CELLS]}
                    enableRowHeader={false}
                    cellRendererDependencies={[tags.tags, loadThumbnailCache]}
                    rowHeights={tags.tags.map(t => t.has_photo ? 80 : 20)}
                >
                    <Column id={COLUMN.VIEWPOINT} name={'Nézőpont'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.PANODATE} name={'Fotózva'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.TAG} name={'Címke'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.STATUS} name={'Státusz'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.DISCIPLINE} name={'Szakág'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.CATEGORY} name={'Kategória'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.DATE} name={'Címke készült'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.TITLE} name={'Megnevezés'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.COMMENT} name={'Megjegyzés'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.EDITEDBY} name={'Készítette'} cellRenderer={cellRenderer} />
                    <Column id={COLUMN.PHOTO} name={'Fotó'} cellRenderer={cellRenderer} />
                </Table2>
            </div>
        </>
    );
}